// extracted by mini-css-extract-plugin
export default {"pageWrap":"ic-z","fullWidth":"jc-z","heading":"kc-z","fullBleed":"lc-z","hidden":"mc-z"};